/* eslint-disable object-shorthand */
import DoubleCheckIcon from 'Components/common/assets/svgIcons/DoubleCheckIcon';
import { selectCurrentHubView, selectEntitiesLoaded, selectSelectedDocumentsCount, selectShowSelected } from 'Selector/DocumentHubSelector';
import {
  maxMobile,
  maxWidth, primaryColor, primaryFont, retina, wMBold,
  wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Wrapper = styled.div<{ btnWidth?: number }>`
&.footerSelected {
  justify-content: space-between;
  align-items: center;
  .selected-docs-div {
    width: calc(100% - ${(props) => props.btnWidth}px);
  }
}
display: flex;
flex-direction: row;
justify-content: flex-end;
// border-top: 1px solid #DADADA;
padding: 22px 24px 22px 40px;
@media all and (max-width: ${maxWidth}),${retina} {
  padding: 18px 24px 18px 40px;
}
@media all and (max-width: ${maxMobile}) {
  justify-content: center;
  padding: 10px 24px 10px 24px;
}
.selected-docs-div {
  display: flex;
  align-items: center;
  .double-check-icon {
    width: 22px;
    min-width: 22px;
    height: 22px;
    margin-right: 8px;
  }
  .selected-dox-text {
    color: ${primaryColor};
    font-family: ${primaryFont};
    font-size: 18px;
    font-weight: ${wMedium};
    letter-spacing: -0.633px;
  }
}
.buttons-div{
  min-width: max-content;
}
.smart-btn {
  font-family: ${primaryFont};
  font-weight: ${wMBold};
  font-size: 16px;
  line-height: 22px;
  border-radius: 23px;
  border: 1.6px solid ${primaryColor};
  background-color: #fff;
  padding: 4px 26px;
  color: ${primaryColor};
  cursor: pointer;
  @media all and (max-width: ${maxWidth}),${retina} {
    font-size: 14px;
    padding: 3px 20px;
  }
  &.next-btn {
    color: #fff;
    background-color: ${primaryColor};
    margin-left: 8px;
  }
  &.disabled{
    pointer-events: none;
    opacity: 0.6;
  }
}
  .highlightedComponent{
    z-index: 1001; // to increase z-index than the overlay
  }
`;
type Props = {
  isNextDisable: boolean,
  showSelectedDocs: boolean,
  isBackDisable: boolean,
  nextBtnText: string
  onBack: () => void,
  onNext: () => void,
  getSelectedDocs?: () => void,
  highlightedComponent: boolean
  showBackButton?: boolean
};

const defaultProps = {
  showBackButton: true,
}

const SmartPlanSliderFooter = function SmartPlanSliderFooter(props: Props) {
  const buttonDevRef = useRef<HTMLDivElement>(null);
  const selectedDocumentCount = useSelector(selectSelectedDocumentsCount);
  const showSelected = useSelector(selectShowSelected);
  const loaded = useSelector(selectEntitiesLoaded);
  const currentView = useSelector(selectCurrentHubView);
  const text = currentView === 'document' ? 'documents' : currentView === 'folder' ? 'folders' : 'items';

  const {
    isNextDisable, isBackDisable, nextBtnText, onBack, onNext, showSelectedDocs,
    highlightedComponent,
  } = props;
  return (
    <Wrapper
      btnWidth={buttonDevRef.current?.clientWidth}
      className={classNames(
        'smart-account-footer',
        {
          footerSelected: selectedDocumentCount
            && showSelectedDocs && !showSelected && loaded,
        },
      )}
    >
      {showSelectedDocs && selectedDocumentCount && !showSelected && loaded ? (
        <div
          tabIndex={0}
          role="button"
          onClick={() => { }}
          onKeyPress={() => { }}
          className="selected-docs-div"
        >
          <DoubleCheckIcon />
          <span className="selected-dox-text text-truncate">
            {selectedDocumentCount}
            {' '}
            {selectedDocumentCount === 1 ? text.slice(0, -1) : text}
            {' '}
            selected
          </span>
        </div>
      ) : null}
      <div className="buttons-div" ref={buttonDevRef}>
        {props.showBackButton && <span
          tabIndex={0}
          role="button"
          onClick={() => onBack()}
          onKeyPress={() => onBack()}
          className={classNames('smart-btn', { disabled: isBackDisable })}
        >
          Back
        </span>}
        <span
          tabIndex={0}
          role="button"
          onClick={() => onNext()}
          onKeyPress={() => { if (!isNextDisable) { onNext(); } }}
          className={classNames('smart-btn next-btn', { disabled: isNextDisable }, {
            highlightedComponent: highlightedComponent,
          })}
        >
          {nextBtnText}
        </span>
      </div>
    </Wrapper>
  );
};
SmartPlanSliderFooter.defaultProps = defaultProps;
export default SmartPlanSliderFooter;
